import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'markant-platform-further-qualification-dialog',
  templateUrl: './further-qualification-dialog.component.html',
  styleUrls: ['./further-qualification-dialog.component.scss'],
})
export class FurtherQualificationDialogComponent {
  @Output() shouldClose = new EventEmitter<boolean>();

  level2Customer = false;
  level2CustomerWithOpenFurtherQualificationProcess = false;

  constructor(private readonly router: Router) {}

  closeDialog(): void {
    this.level2Customer = false;
    this.level2CustomerWithOpenFurtherQualificationProcess = false;
    this.shouldClose.emit(true);
  }

  async toFurtherQualificationForm(): Promise<void> {
    await this.router.navigate(['/enable-organization']);
    this.shouldClose.emit(true);
  }
}
